try{self['workbox:window:4.1.1']&&_()}catch(e){}// eslint-disable-line